const FileUpload = class FileUpload {
    constructor(config) {

    }

    init(fileUploadInput, uploadTriggerBtn, fileName, removeIcon) {
        let fileUpload = $(fileUploadInput),
            uploadTrigger = $(uploadTriggerBtn),
            label = $(fileName),
            removeFile = $(removeIcon);

        uploadTrigger.click(function () {
            fileUpload.click();
            fileUpload.on('change', function (e) {
                let fileName = '';
                if (this.files && this.files.length > 1) {
                    fileName = ( this.getAttribute('data-multiple-caption') || '' ).replace('{count}', this.files.length);
                }
                if (e.target.value) {
                    fileName = e.target.value.split('\\').pop();
                }
                if (fileName) {
                    label.find('.js-file-name-text').text(fileName);
                    label.addClass('has-file');
                }
            });

            // Firefox bug fix
            fileUpload.on('focus', function () {
                fileUpload.addClass('has-focus');
            })
                .on('blur', function () {
                    fileUpload.removeClass('has-focus');
                });
        });

        removeFile.click(function (e) {
            e.preventDefault();
            label.find('.js-file-name-text').text('');
            label.removeClass('has-file')
            fileUpload.find('input').val('');
        });

    }
};

export {FileUpload};


// WEBPACK FOOTER //
// ./static/js/components/FileUpload.js